import { Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from '../../../Data/DataTable/DocumentList/DocumentList';
// import axios from 'axios';
import EditDocument from './EditDocument';
import { Link } from 'react-router-dom';
import AddTag from './AddDocument';
import { ServerPath } from '../../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import {_axios } from '../../../utils/axios'; 


const DataTablesContain = () => {
  const [documentList, setdocumentList] = useState([]);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/document`);
        const actualData = response?.data?.data;
        const docData = actualData.map(Document => ({
          ...Document,
          document_name: <div className="align-self-center"><div>{Document?.document_name}</div></div>,
          status: <span
            className={`badge rounded-pill ${Document?.status === 1 ? 'badge-success' : 'badge-danger'}`}
            data-bs-toggle="modal"
            data-bs-target=".bd-example-modal-sm"
          >
            {Document?.status === 1 ? 'Active' : 'Inactive'}
          </span>,
          action: (
            <div className="action d-flex justify-content-center">
              <div className="edit" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                {Document && <EditDocument data={Document} />}
              </div>
              <div className="delete">
                <Button onClick={(e) => handleDeleteID(Document?.doc_id, e)} className="btn-square btn btn-danger mx-2"><i className="icon-trash"></i></Button>
              </div>
            </div>
          ),
        }));
        setdocumentList(docData);
      } catch (error) {
        console.error('Error fetching documentList:', error);
      }
    };
    fetchdata();
  }, []);

  const handleDeleteID = async (doc_id, event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      customClass: {
        container: 'swal2-container'
      }
    });

    if (result.isConfirmed) {
      try {
        await _axios.delete(`${ServerPath}/document/${doc_id}`);
        setdocumentList(prevUsers => prevUsers.filter(doc => doc.doc_id !== doc_id));
        Swal.fire(
          'Deleted!',
          'Your document has been deleted.',
          'success'
        );
      } catch (error) {
        console.error('Error deleting document:', error);
        Swal.fire(
          'Error!',
          'There was an error deleting the document.',
          'error'
        );
      }
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
      setToggleDelet(!toggleDelet);
      setdocumentList(documentList.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
      setSelectedRows('');
    }
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Document List" parent="Tables" title="Document List" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <AddTag />
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              {/* <HeadingCommon Heading={DataTableHeading}  /> */}
              <CardBody className='pt-0'>
                {(selectedRows.length !== 0) &&
                  <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data?</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                  </div>
                }
                <DataTable
                  className='data-tables theme-scrollbar pt-4'
                  data={documentList}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelet}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>

  );

};
export default DataTablesContain;